export { MODULE_NAME } from './payment-thanks.constants';
export { store } from './payment-thanks.store';
